export const CISCO_CRITERIA = {
  CISCO: [
    {
      Criteria: "Price",
      Model: "Insourcing/Co-Managed",
      Questions: "Hardware Price Available?",
      Check: "Yes",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Price",
      Model: "Outsourcing",
      Questions: "Price per site Tier Available?",
      Check: "Yes",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Price",
      Model: "Insourcing/Co-Managed",
      Questions: "Licensing (# users, bandwidth, length of time, fixed)",
      Check: "Yes",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Hardware Availability",
      Model: "All",
      Questions: "How available is the necessary hardware? (Lead times)",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Most - 4 weeks lead times. There are some specialty versions of the device that differ.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How is path selection determined? (jitter, latency, packet loss)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Path selection is done with the metrics mentioned as well as additional information such as: data gathered by Cisco's cloud deployed thousand eyes sensors within the ISP via WAN Insights. https://www.thousandeyes.com/product/wan-insights",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can path selection be dynamically configured?",
      Check: "Yes",
      Rating: 3,
      Notes: "Configuration can be changed and updated dynamically",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "What path selection options can be set?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Path selection can be modified using a combination of loss, latency, and jitter using Bidirectional Forwarding Detection (BFD) probes",
    },
    {
      Criteria: "Path Selection",
      Model: "Insourcing/Co-Managed",
      Questions: "Can traffic be tagged based on rules?",
      Check: "Yes",
      Rating: 3,
      Notes: "Multiple tagging options exist such as DSCP, VLAN, and SGT",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can traffic be prioritized based on QOS or traffic tags?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Tags can be used to schedule, queue, shape and police traffic on interfaces within the fabric and when the traffic exits the SDWAN fabric on the far end.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can path load sharing be configured?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Bandwidth Augmentation, allows customers to increase WAN bandwidth by leveraging all available WAN transports and routing capabilities to distribute traffic across available paths in an active/active fashion.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can traffic steering be configured?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Enhanced Policy Based Routing (ePBR) is available with C3PL matching",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution utilize traffic shaping to prioritize traffic for critical applications?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Queuing, Scheduling, Shaping and Policing are all available tools for application prioritization",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution automatically select the best transport layer path based on performance metrics?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "When defining an applications Service Level Agreement you can define which peformance metrics are required and then trigger path selection based off these thresholds.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can the solution offer automated network failover?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Path selection can failover automatically as thresholds are exceeded during a blackout or brownout scenario",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution optimize access to popular SaaS applications?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cloud onramp for SaaS allows the SDWAN locations to intelligently provide connectivity into popular SaaS applications. Additionally synthetic tests can be run to simulate traffic into popular SaaS applications to showcase different KPI's when user traffic is not active. ",
    },
    {
      Criteria: "Path Selection",
      Model: "Insourcing/Co-Managed",
      Questions: "Are there AI features for path selection?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "There are Machine Learning algorithms built into the WAN Insights component which are helpful in determining optimal path. https://www.thousandeyes.com/product/wan-insights",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Does solution detect and respond to a link-layer brownout? How?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can solution detect and respond to an application brownout? How? ",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Describe the system's link selection capabilities. Are they available per application?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How does the solution monitor application reachability across multiple links?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Describe how the solution handles end-user connections (TCP flows) when traffic has to be moved from one link to another. Are sessions terminated or maintained?",
      Check: "Yes",
      Rating: 3,
      Notes: "Maintained",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How does the solution maintain flow symmetry and correct flows when asymmetry is detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Dynamic Path Control and First-packet iQ maintain symmetry. Adjusts routing policies to steer flows to symmetric paths.",
    },
    {
      Criteria: "Transport Layer Connectivity",
      Model: "All",
      Questions:
        "Can the solution support all types of WAN transport layer connection types?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "An extremly wide variety of modules are available to support a large variety of transport media.",
    },
    {
      Criteria: "Transport Layer Connectivity",
      Model: "All",
      Questions:
        "All transport layer technologies are supported? Which ones are not?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "47 Different types of NIM modules are available for everything from ISDN to 5G cellular.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions: "Are Dynamic Protocols supported? Please list.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "BGP, OSPF, EIGRP and RIP are all supported as well as OMP - an extension to BGP designed specifically for SDWAN environments",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions:
        "Does the solution operate without restrictions to any protocols?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Scale and performance of route tables is dependant on the configuration of the edge router, and installed modules.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there any routing best practices for the product? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "There is a significant database of Cisco Validated Design (CVD) documents",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Outsourcing",
      Questions:
        "Can the Client control routes at the edge in the MSP scenario?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The short answer is Yes, but for a more clear answer it would be important to understand if MKS would be a customer for an external MSP, or if MKS would be acting as an MSP for its internal divisions. ",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can the solution support multiple circuit carriers in active/active connection setup?",
      Check: "Yes",
      Rating: 3,
      Notes: "This is a core tenant of Catalyst SDWAN",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Can routing be controlled at the edge?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Optimal SDWAN routing is calculated by the overlay, but local routes can be configured on the edge",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does solution not require data-plane traffic to transit through single or multiple POPs (Point of Presence). Does solution operate without remote GW requirement?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions:
        "How does the solution integrate natively with existing MPLS WAN networks? Can the overlay and underlay be used simultaneously?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions: "Does the solution offer redundancy options (specify)? ",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Options exist for redundant power, route processors, overlay and management devices.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Is there no requirement for additional equipment besides the redundant SD-WAN appliance?",
      Check: "Yes",
      Rating: 3,
      Notes: "For hardware redundancy, duplicate hardware is required",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Outsourcing",
      Questions: "What are failover and recovery speeds?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "BFD provides controls for subsecond failover. Timers in the SLA can be configured to optimise application aware routing failover. The controller cluster is designed to be actively redundant and routers will continue operating if communication is lost to the controllers.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution include HA capabilities without requiring additional licensing? If not, please describe the licensing structure.",
      Check: "No",
      Rating: 1,
      Notes: "Additional licensing for HA appliance throughput",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution work without WAN-side switches and/or unique ISP addresses?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution support fail-to-wire interfaces (multi-networking failover interfaces)?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can and how does the solution operate when it is unable to communicate with its controller or orchestration function (if any)?",
      Check: "Yes",
      Rating: 3,
      Notes: "Forwards traffic based on locally cached policies and routes.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution support link capacity monitoring without flooding the link?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution maintain 100% of the WAN capacity in the event of a unit failure?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Geographic Coverage",
      Model: "All",
      Questions: "Are there no geographic deployment restrictions?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Export restriction (HSEC) licenses are required for high encryption devices used outside the united states.",
    },
    {
      Criteria: "Geographic Coverage",
      Model: "All",
      Questions:
        "What is the experience utilizing the solution in countries like China?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN is designed to be deployed globally. In countries with specific legal restrictions like China there are well tested partnerships. For example China Telecom offers a secure method for extending the fabric into the country. https://www.ctamericas.com/products/data-networking/hybrid-wan/ Additionally 8000v virtual routers are tested in Alibaba Cloud China.",
    },
    {
      Criteria: "Support",
      Model: "Insourcing",
      Questions: "Is solution documentation access available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The cisco solution is very well doccumented, access to doccumentation is available within the product management interface as well as through design guides.",
    },
    {
      Criteria: "Support",
      Model: "Insourcing",
      Questions: "Are training options available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Instructor led trainings as well as Cisco University prepared content are available. ",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer Zero Touch Provisioning?  If so, please describe the process.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Edge devices can be shipped directly to the deployment location and automatically call back to the centeral server for configuration. Optionally devices can be configured to reach out to Cisco's cloud service to connect them to the customers configuration server",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If ZTP is offered, does it operate without special DNS/DHCP records?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "There are many options for ZTP - Optionally DNS and DHCP can be used, or the cloud hosted ztp portal can be used to connect edge routers to their management service.",
    },
    {
      Criteria: "New Rollout",
      Model: "All",
      Questions:
        "Does the solution offer integration with Legacy Infrastructures?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "The majority of supported Cisco routers can participate in a modern SDWAN fabric.",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions: "Is there a templating feature? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Templates can be configured via the centeralized management console and deployed on a per device basis. Template settings are a useful way to keep configuration consistant and minimize configuration drift.",
    },
    {
      Criteria: "New Rollout",
      Model: "All",
      Questions: "How many hours does a new site turn-up normally take?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Small sites can be turned up in minutes, larger locations can take a few hours depending on the logistics available at the facility.",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "Are there no node limitations or restrictions?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "There are successful Cisco SDWAN deployments with thousands of locations",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "Are there no tunnel limitations or bandwidth?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Throuhgput capabilities are licensed in tiers, and each physical model has a limit to how much capacity it can handle. 8200: 2500 tunnels, 1000: 200 tunnels, 8500: 10k tunnels",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there no limitations on logical WAN interfaces? If so, please describe ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Although it is not possible to say logical WAN interfaces are limitless, we have thousands of successful deployments and any hardware limiation we have encountered we have been able to design around. If you have any concerns about a specific limitation please let us know and we will work to find a successfull design.",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "No deployment architecture options and limitations? (little interest in hub & spoke)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The SDWAN fabric is designed to be highly flexible in deployment options, everything from hub-spoke to full mesh are possibilities. Because the overlay is maintained by the controllers the burden of scale is removed from the individual routers. ",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution support hub and spoke VPN topologies? Are multiple hubs supported?  (little interest in hub & spoke)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN supports hub and spoke VPN architectures and allows for multiple hubs in active-active or active-passive setups.",
    },
    {
      Criteria: "Scalability",
      Model: "Outsourcing",
      Questions:
        "If managed hardware solution, can the circuits be brought into existing hardware?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "The existing MKS Catalyst 8300's support SDWAN functionality, the ISR4000 series that MKS has are also capable of running SDWAN functions, but due to their age it is reccomended they be upgraded to the latest generation for optimal performance.",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions:
        "Describe the steps for migrating a hybrid WAN (MPLS primary, Internet backup) solution into a SDWAN? Are there no disruptiions?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "No other scalability limitations?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The design guide (included) has validated configurations for deployments with 4,000 locations. There are larger deployments, but for scalability beyond 4,000 locations we recommend collaborating with your Cisco team.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer a Single Pane of Glass?",
      Check: "Yes",
      Rating: 3,
      Notes: "Cisco SDWAN Manager is the centeralized place for management",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution allow management through the SSL portal? If yes does it support MFA and AD integration? SAML/SSO?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Management traffic is SSL encrypted and supports MFA and AD integartion",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions: "Does the solution offer performance visibility?",
      Check: "Yes",
      Rating: 3,
      Notes: "Monitoring performance is a key tenant of SDWAN",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "Does the solution support Third-Party Application Integration?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Catalyst SDWAN Integrates with a variety of 3rd party applications. For more details on how a specific application can be integrated please provide a list and desired integration.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Does solution not require an Engineer to Node?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions: "Does the solution offer API integration?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "There is a comprehensive set of API endpoints available for configuration management and monitoring of Catalyst SDWAN. Sandboxes and Code Exchange is avaiable at cisco's DevNET site with learning labs available to showcase popular uses of the API https://developer.cisco.com/sdwan/",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "Does the API provide access to 100% of the features and functions of the solution?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Is the solution's management platform self-hosted, or vendor provided?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The management platform can optionally be self hosted or provided by Cisco as preferred by the customer.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If vendor-provided, what underlying platform is being used (GCP/AWS/Azure/etc.)? What's the support model? Are there no regional limitations?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco utilizes a Tier1 cloud provider for the resources. The overlay backend is managed by Cisco with the customer maintaining responsibility for managing the configuration of their specific devices",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If not vendor-provided, how is it deployed/managed? How does it scale?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Overlay Management Protocol is used for signaling between the four key components: Manager, Controller, Validator, WAN Edge device. An extremly high degree of scalability is available.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Ease of Use? (new employee turn-up, vendor-specific terminology)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The configuration interface is easy to navigate and the detailed doccumentation and configuration guides make it easy to deploy.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Describe the upgrade process required to upgrade the solution?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Controller-Based Upgrades via vManage. Cisco SD-WAN  upgrades are managed through the vManage controller. Firmware is uploaded to vManage, devices are staged for upgrade, and updates are deployed in phases to ensure minimal downtime. Rollbacks are supported if issues occur during or after the upgrade. The process supports high availability by upgrading devices in sequence.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Are there generative AI capabilities for management?",
      Check: "No",
      Rating: 1,
      Notes:
        "Roadmapped: Short term.  Cisco has been developing an AI Assistant to integrate across all Cisco products.  This LLM has been specifically trained on millions of data points surrounding the most popular configuration and management requests. More details about Cisco's AI assistant will be updated here: https://www.cisco.com/site/us/en/solutions/artificial-intelligence/ai-assistant/index.html",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "What is the licensing model for the solution? Please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Licensing can be done on an a-la-carte basis where each device is licensed for a term at a bandwidth tier. Or alternatively the preferred method is to license via an Enterprise Agreement which offers a high degree of flexibility for deployment roll outs that take time.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions: "Does the solution have an automation feature set?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Troubleshooting recomendations can be made from within the management",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution offer integration with other troubleshooting projects?",
      Check: "Yes",
      Rating: 3,
      Notes: "The ThousandEyes tool is tightly integrated",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution support live packet capture for troubleshooting purposes?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN  supports live packet capture through the vManage controller. Administrators can initiate packet captures from specific devices and export them for analysis using tools like Wireshark.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions: "Does the management solution support inline ticket creation?",
      Check: "No",
      Rating: 2,
      Notes:
        "Cisco SD-WAN  vManage does not natively support inline ticket creation but provides logs and diagnostics that can be manually entered into ITSM systems. Integrations with external tools like ServiceNow or Jira are commonly used for ticketing.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Can network administrator use the solution to troubleshoot an end-user specific reported application performance problem?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Are there any native testing tools available for troubleshooting? If so, what are they?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Ample tools are built into the management portal natively for troubleshooting and comparing to baseline conditions. Logs can automatically be gathered in the event of an anomoly.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution offer Artificial Intelligence capabilities? If so, please describe.",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Predictive Path Analyitcs can be enabled to automate the application of policy based off cloud conditions. Bandwidth forecast is available for capacity planning, giving operators insights into possible future network usage based on extensive past usage patterns.",
    },
    {
      Criteria: "Technical Support",
      Model: "All",
      Questions:
        "Does the solution offer 24/7 technical support with defined service levels for response and resolution time? ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Around the clock support is available with service personel ready to serve every timezone. Cisco TAC has over 7,000 support engineers holding 19,000 certifications, operating in 193 countries.  There are 1300 fulfillment centers for replacement parts strategically positioned around the globe. ",
    },
    {
      Criteria: "Technical Support",
      Model: "Insourcing/Co-Managed",
      Questions: "Is solution training available?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions:
        "How long is an estimated MTTR of a defective gateway appliance (what are support options)?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Appliances have replacement options from Next Business Day, to 2 hour Onsite.",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions: "What are the SLA support options available, list.",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions: "Are there financial implications for breaching SLA, explain?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Are reporting capabilities available? Describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "An extensive number of pre built reports are available with on-demand, live data, and scheduled reporting options",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "What types of data can be reported?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The following reports are available in Cisco SD-WAN Manager:\r\nExecutive Summary Report, Link Availability Report, Site Availability Report, Link Utilization Report, Link SLA Report, Application Usage Report, IPS Event Collection Report, Firewall Enforcement Report, \r\nMalware File Collection Report, Internet Browsing Report, All Applications Report.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Can KPI data baselines be calculated automatically?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "The management interface can show you the baseline for an enviornment and how current conditions deviate from it.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there network-wide insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Detailed Metrics and Visualizations provides network-level information for a location. The management interface has visual representations such as topology graphs and geograhic views, illustrating the end-to-end flow and associated metrics.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there site-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Site Health is defaultly included in the main overview page. It categorizes sites by performance but the data can easily be pivoted to view apps, app usage, tunnels etc. In the geography view it is easy to click on a map of a physical location and view all of the resources available in that location. ",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there device-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "While all reporting is handled centrally, at the device level it is possible to view locally relevant information like interface utilization, CPU, fan speed, temperature ETC. For most reporting tasks the centeral report is best.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Are there link-level performance metrics available?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there application-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, both observed metrics as well as synthetic testing can be used to montitor application level insights.  An application performance monitor can be configured with granular configuration : https://www.cisco.com/c/en/us/td/docs/routers/sdwan/configuration/policies/ios-xe-17/policies-book-xe/m-application-performance-monitoring.html",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are performance metrics available for sub-applications (e.g. Gmail vs. all Google apps)?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are full performance monitoring capabilities available for traffic using direct-to-internet paths?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there end-user insights available? If so, please describe.",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Can the data be reported in a visually appealing format? (Graphs, illustrations, etc.)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Both the real-time reporting as well as the scheduled and historical reports provide the ability to produce graphical representations of traffic flows. There are also integrations into external visual reporting tools like Cisco Splunk or grafana",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Can data reporting be filtered by different time frames?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The default view is set to 24 hours, but can be switched with one click to 1, 3, 6, 12h or 7 days. A custom option is also available for custom timeframes",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Is this solution application-aware?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Enhanced Application-Aware Routing (EAAR): EAAR improves the accuracy of performance measurements by utilizing inline data packets, leading to faster detection of tunnel performance issues.",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions:
        "Can traffic be dynamically steered based on real-time network performance and application priority?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "When defining an applications SLA you can set thresholds that will controll the dynamic steering of traffic based off performance changes",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application bandwidth be detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Application bandwidth consumption can be tallied and the data can be pivoted based off users, tunnels, locaitons etc.",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application latency be detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Application latency can be detected and used for routing decisions",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application jitter be detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Application jitter can be detected and used for routing decisions",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application loss be detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Application packet loss can be detected an dused for routing decisions",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions:
        "Can the solution throttle at the application level (similar to application-based QoS policy)?",
      Check: "Yes",
      Rating: 3,
      Notes: "Application based QoS is supported",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Can policies be built based on tagged traffic?",
      Check: "Yes",
      Rating: 3,
      Notes: "Traffic tags can be used when defining security policy",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer granular security policies?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Granular policy can be achieved through the SDWAN policy framework with options for Centeralized and Local policies. There is also the option to push traffic to external enforcement tools or route data through Cisco's highly scalable Secure Access cloud for inspection.",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Is there an application policy enforcement feature?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The L7 Traffic identification capabilities allow for enforcement of security policy at the application layer",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer monitoring and policy control based on user identity and user group membership?",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution incorporate DLP mechanisms?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN DLP (Data Loss Prevention) is a security feature that protects data in a variety of storage mediums, including the cloud. It helps ensure that only authorized users can access data and tracks their access in case it is stolen or leaked. \r\nHere are some features of Cisco SD-WAN DLP:\r\nCloud data loss prevention: Analyzes outbound web traffic to provide control over sensitive data leaving an organization \r\nSaaS API data loss prevention: Can be enabled for tenants of AWS, Azure, Box, Dropbox, Google Drive, Microsoft 365, ServiceNow, Slack, and Webex Team.",
    },
    {
      Criteria: "Security Policy",
      Model: "All",
      Questions: "Does the solution allows login based on SSO?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The solution is compatible with Multiple IdP's (up to 3 at a time) including Azure AD, Okta, ADFS, PingID and SAML 2.0 compliant services.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "Does the solution offer protection for the SD-WAN edge devices? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The Catalyst SDWAN solution has an industry leading architecture for trustworthy systems, including device certificates, cross fabric authentication, signed code, and high security encryption. Details are available here: https://www.cisco.com/c/dam/en_us/about/doing_business/trust-center/docs/trustworthy-technologies-datasheet.pdf",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "Describe how secret key material is protected throughout the entire provisioning and de-provisioning lifecycle?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN  uses secure key exchange (e.g., TLS/IPsec) and centralized management via vManage. Key material is encrypted during storage and transport. When devices are de-provisioned, keys are securely invalidated to prevent unauthorized use.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "If a unit is lost or compromised, how is key information protected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN  encrypts key material during storage and transport. In case of compromise, vManage immediately revokes the device’s keys, isolating it from the network. Re-provisioning requires secure reauthentication.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "What mechanisms are in place to prevent a compromised unit from gaining network access?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN  uses PKI-based certificates for device authentication. If a unit is compromised, vManage can revoke the certificate, effectively isolating the device. The architecture also enforces a “deny by default” policy for untrusted devices.",
    },
    {
      Criteria: "NAT",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can source and destination Network Address Translation (NAT) be configured?  -(Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Ample NAT configuration options are available with detailed documentation here: https://www.cisco.com/c/en/us/td/docs/routers/sdwan/command/iosxe/qualified-cli-command-reference-guide/m-NAT-commands.html",
    },
    {
      Criteria: "NAT",
      Model: "Insourcing/Co-Managed",
      Questions:
        "What types of NAT are supported?  (Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Ample NAT configuration options are available with detailed doccumentation here: https://www.cisco.com/c/en/us/td/docs/routers/sdwan/command/iosxe/qualified-cli-command-reference-guide/m-NAT-commands.html",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution meet U.S. encryption import/export guidelines and laws?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "HSEC Export restriction licenses are required for devices that are enabled for high encryption that will be exported outside the united states",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Does the solution use a single shared encryption key or multiple encryption keys between tunnels?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Are tunnel encryption keys rotated? How often are tunnel keys rotated?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN rotates IPsec encryption keys periodically to minimize risks. The default interval is one hour, but administrators can configure this based on organizational requirements.",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Does the solution support latest standard for end-to-end traffic encryption? (AES- 256)",
      Check: "Yes",
      Rating: 3,
      Notes: "AES-256 is supported ",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution have stateful firewalling? ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Stateful firewalling is supported with configuration options available here: https://www.cisco.com/c/en/us/td/docs/routers/sdwan/configuration/security/ios-xe-17/security-book-xe/m-firewall-17.html",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer Deep Packet Inspection?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Stateful firewall with a DPI engine for application detection. The firewall provides app visibility capable of detecting 1400+ apps.",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer an IDS & IPS feature?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The SDWAN device monitors network traffic and analyzes against a defined rule set, performs attack classification and invokes actions against matched rules. Details are available here: https://www.cisco.com/c/en/us/td/docs/routers/sdwan/configuration/security/ios-xe-17/security-book-xe/intrusion-prevention.html",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer antivirus and antimalware protection?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The SD-WAN AMP integration is an integral part of the SD-WAN edge security solution that aims visibility and protection for users at a branch from Malware.  Details are available here: https://www.cisco.com/c/en/us/support/docs/routers/xe-sd-wan-routers/217641-configure-sdwan-advanced-malware-protect.html",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions: "Can security rules be put in place for layer 4-7?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Application layer security can easily be enabled, there are a variety of options available to the security policy based off the individual application type. The Cisco Validated Design for Application Aware Security Policy in SDWAN Fabrics is a good place to start regarding all of the options available for L4-7 security: https://www.cisco.com/c/en/us/td/docs/solutions/CVD/SDWAN/cisco-sdwan-security-policy-design-guide.html",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions: "Are application/layer 7 rules supported?",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can custom applications be defined based on URL or domain and subdomain? (E.g. example.com, crm.example.com)",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Do custom applications receive 100% of the feature/functionality as built-in/system applications?",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "Does the solution have the ability to segment traffic?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Traffic segmentation can be maintained across the WAN. Traffic that enters the router is assigned to a VPN, which not only isolates traffic, but also provides routing table isolation. When traffic is transmitted across the WAN, a label is inserted after the ESP header to identify the VPN that the user’s traffic belongs to when it reaches the remote destination.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "Describe how traffic may be separated for different device types and pools?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN (Viptela) supports segmentation using Virtual Routing and Forwarding (VRF-Lite) and application-aware policies. Administrators can create logical segments for different device types or traffic pools, ensuring complete isolation and secure transport.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "When traffic separation is in place, is a different encryption key used for VPN tunnels?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN (Viptela) uses separate encryption keys for each VPN tunnel. Traffic segmented by VRFs or application-aware policies is cryptographically isolated using distinct keys for each tunnel.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "Is the network segmentation capability PCI-compliant?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN (Viptela) supports PCI-compliant segmentation by implementing VRF-Lite and application-aware routing. It isolates cardholder data traffic securely and supports audit-ready reporting.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "How does segmentation integrate with legacy Infrastructure?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "There are multiple options for integration with legacy infrastucture. Common strategies include mapping traffic to specific interfaces, vLAN's, VPNs or tagging packet headders with SGTs. ",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "Does SD-WAN solution capable to secure IoT devices? Is there a need for additional hardware to secure IoT?",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "DDOS Protection",
      Model: "Co-Managed/Outsourcing",
      Questions: "How is DDOS Protection Supported/Achieved",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Based on Zero trust and Control plane policing. To secure remote site Internet access from DDoS attacks. For this use case, Enterprise firewall with Application Awareness is configured to inspect and limit access to cloud applications, Snort IPS/IDS to inspect & block known attack or malware signatures, URL Filtering (URLF) for content filtering, Advanced Malware Protection (AMP) to prevent download of malicious content or file, and DNS/Web-layer security as an additional layer of protection at the DNS layer. Details are addressed in the previously mentioned Security Policy Design Guide",
    },
    {
      Criteria: "FIPS Compliant",
      Model: "All",
      Questions: "Is the device FIPS Compliant?",
      Check: "Yes",
      Rating: 2,
      Notes: "FIPS compliant hardware options are available",
    },
    {
      Criteria: "FIPS Compliant",
      Model: "All",
      Questions: "Are there any other Compliance Standards?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Cisco maintains a database with compliance standards for each part including RoHS, NEBS, CE, and others. Declarations of conformity can be obtained here: https://cae-cnc-prd.cisco.com/pdtcnc/#/",
    },
  ],
};
